<template>
  <v-layout wrap :row="row" :column="!row">
    <v-flex xs4 pr-1>
      <v-autocomplete
        clearable
        v-model="selectedTERC.woj"
        item-text="name"
        item-value="woj"
        :items="wojs"
        :label="labelWoj"
        :errorMessages="this.model.woj.$error"
        @focus="focus('woj')"
        @blur="blur('woj')"
        @change="changeWoj"
      ></v-autocomplete>
    </v-flex>

    <v-spacer></v-spacer>

    <v-flex xs4 px-1>
      <v-autocomplete
        v-if="selectedTERC.woj"
        clearable
        v-model="selectedTERC.pow"
        item-text="name"
        item-value="pow"
        :items="pows"
        :label="labelPow"
        :errorMessages="this.model.pow.$error"
        @focus="focus('pow')"
        @blur="blur('pow')"
        @change="changePow"
      ></v-autocomplete>
    </v-flex>

    <v-spacer></v-spacer>

    <v-flex xs4 pl-1>
      <v-autocomplete
        v-if="selectedTERC.pow"
        clearable
        v-model="selectedTERC.gmi"
        item-text="name"
        item-value="gmi"
        :items="gmis"
        :label="labelGmi"
        :errorMessages="this.model.gmi.$error"
        @focus="focus('gmi')"
        @blur="blur('gmi')"
        @change="changeGmi"
      ></v-autocomplete>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios';
import { TercType } from '@witkac/kartamiejska-shared';

import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Input na TERC-a
// @group Components/Forms
export default {
  mixins: [notificationsMixin],
  props: {
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Nazwa pola z TERC-em
    field: {
      type: String,
      required: false,
      default: 'terc'
    },
    row: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      wojs: [],
      pows: [],
      gmis: [],
      selectedTERC: {},
      labelWoj: this.model[this.field].$schema.fieldRequired
        ? 'Województwo *'
        : 'Województwo',
      labelPow: this.model[this.field].$schema.fieldRequired
        ? 'Powiat *'
        : 'Powiat',
      labelGmi: this.model[this.field].$schema.fieldRequired
        ? 'Gmina *'
        : 'Gmina'
    };
  },
  methods: {
    // @vuese
    // Ustawianie pól formularza
    setTERCData() {
      this.$set(
        this.selectedTERC,
        'woj',
        this.model[this.field].$value.slice(0, 2)
      );
      this.$set(
        this.selectedTERC,
        'pow',
        this.model[this.field].$value.slice(2, 4)
      );
      this.$set(
        this.selectedTERC,
        'gmi',
        this.model[this.field].$value.slice(4, 6)
      );
    },
    // @vuese
    // Metoda pobiera listę województw
    getWojList() {
      axios
        .get(
          `${process.env.VUE_APP_TERYT_API_URL}/terc/?type=${TercType.WOJEWODZTWO}`
        )
        .then(res => {
          this.wojs = res.data.list.map(item => ({
            woj: item.woj,
            name: item.name.toLowerCase()
          }));
        })
        .catch(error =>
          this.notifyError('Nie udało się pobrać listy województw')
        );
    },
    // @vuese
    // Metoda pobiera listę powiatów
    getPowList() {
      if (this.selectedTERC.woj) {
        axios
          .get(
            `${process.env.VUE_APP_TERYT_API_URL}/terc/?type=${TercType.POWIAT}&woj=${this.selectedTERC.woj}`
          )
          .then(res => {
            this.pows = res.data.list.map(item => ({
              pow: item.pow,
              name: item.name
            }));
          })
          .catch(error =>
            this.notifyError('Nie udało się pobrać listy powiatów')
          );
      }
    },
    // @vuese
    // Metoda pobiera listę gmin
    getGmiList() {
      if (this.selectedTERC.woj && this.selectedTERC.pow) {
        axios
          .get(
            `${process.env.VUE_APP_TERYT_API_URL}/terc/?type=${TercType.GMINA}&woj=${this.selectedTERC.woj}&pow=${this.selectedTERC.pow}`
          )
          .then(res => {
            this.gmis = res.data.list.map(item => ({
              gmi: item.gmi,
              name: item.nameFull
            }));
            if (this.gmis.length === 1) {
              this.selectedTERC.gmi = this.gmis[0].gmi;
              this.changeGmi(this.gmis[0].gmi);
            }
          })
          .catch(error => this.notifyError('Nie udało się pobrać listy gmin'));
      }
    },
    // @vuese
    // Zapisanie i wyczyszczenie w schema odpowiednich pól po wybraniu województwa
    changeWoj(val) {
      this.selectedTERC.pow = undefined;
      this.selectedTERC.gmi = undefined;

      this.model.$setData({
        woj: val ? this.wojs.find(item => item.woj === val).name : '',
        pow: '',
        gmi: '',
        [this.field]: val ? val : ''
      });
    },
    // @vuese
    // Zapisanie i wyczyszczenie w schema odpowiednich pól po wybraniu powiatu
    changePow(val) {
      this.selectedTERC.gmi = undefined;

      this.model.$setData({
        pow: val ? this.pows.find(item => item.pow === val).name : '',
        gmi: '',
        [this.field]: val
          ? `${this.selectedTERC.woj}${val}`
          : `${this.selectedTERC.woj}`
      });
    },
    // @vuese
    // Zapisanie w schema odpowiednich pól po wybraniu gminy
    changeGmi(val) {
      this.model.$setData({
        gmi: val ? this.gmis.find(item => item.gmi === val).name : '',
        [this.field]: val
          ? `${this.selectedTERC.woj}${this.selectedTERC.pow}${val}`
          : `${this.selectedTERC.woj}${this.selectedTERC.pow}`
      });
    },
    focus(field) {
      this.model[field].$hasFocus = true;
    },
    blur(field) {
      this.model[field].$hasFocus = false;
    }
  },
  watch: {
    'selectedTERC.woj'(newValue) {
      if (newValue) {
        this.getPowList();
      }
    },
    'selectedTERC.pow'(newValue) {
      if (newValue) {
        this.getGmiList();
      }
    }
  },
  beforeMount() {
    this.getWojList();
    this.setTERCData();
  }
};
</script>
